/**
 * Spanish Products Translations
 * 产品页翻译模块 - 西班牙语
 *
 * 包含产品列表、产品详情、五个产品完整翻译
 */

import type { ProductsTranslations } from '../../types';

export const esProducts: ProductsTranslations = {
  title: 'Todos los productos',
  subtitle: 'Descubre la solución de calefacción perfecta para tu espacio',
  viewDetails: 'Ver Detalles',
  header: {
    title: 'Todos los productos',
    subtitle: 'Descubre la solución de calefacción perfecta para tu hogar, oficina o espacio industrial.',
  },
  filters: {
    all: 'Todos',
    searchPlaceholder: 'Buscar productos...',
  },
  catalog: 'Descargar Catálogo Completo',
  discoverMore: 'Descubre Más',
  viewSpecs: 'Ver Especificaciones',
  categories: {
    infraredHeater: 'Calefactor de Infrarrojos',
    portableHeater: 'Calefactor Portátil',
    gasHeater: 'Calefactores de gas',
  },
  navDesc: {
    infrared: 'Paneles radiantes de pared y techo',
    portable: 'De pie, de mesa y colgantes',
    gas: 'Calefactores y mesas de fuego',
  },
  viewAllProducts: 'Ver todos los productos',
  gasSubtitle: 'Calefactores de gas y mesas de fuego para terrazas y espacios al aire libre.',
  categoryLanding: {
    gas: {
      title: 'Calefactores de gas y mesas de fuego',
      subtitle:
        'Calefacción al aire libre de 8 kW a 50.000 BTU, con quemadores de acero inoxidable 304, cortavientos de vidrio y configuraciones GLP para tu mercado de destino.',
      empty: 'No se encontraron productos en esta categoría.',
    },
    infrared: {
      title: 'Calefactores de Infrarrojos',
      subtitle: 'Calor radiante diseñado para una calidez eficiente y dirigida—ideal para terrazas, talleres y zonas de confort.',
      empty: 'No se encontraron productos en esta categoría.',
    },
    portable: {
      title: 'Calefactores Portátiles',
      subtitle: 'Soluciones de calefacción flexibles para el hogar y el trabajo—fáciles de mover, rápidas de calentar y pensadas para el confort diario.',
      empty: 'No se encontraron productos en esta categoría.',
    },
  },
  detail: {
    technicalSpecs: 'Especificaciones Técnicas',
    relatedProducts: 'Productos relacionados de {{category}}',
    requestQuote: 'Solicitar Cotización',
    backToProducts: 'Volver a Productos',
    productNotFound: 'Producto no encontrado',
    specsAvailableOnRequest: 'Especificaciones disponibles bajo solicitud.',
    noMatchingProducts: 'No hay productos que coincidan',
    noProducts: 'No hay datos de productos',
  },
  items: {
    p1: {
      name: 'Serie 13A',
      description: 'Serie fiable de calefactores radiantes por infrarrojos lejanos con múltiples opciones de potencia. Ideal para patios, restaurantes, talleres y montaje en pared. Eficiencia energética con protección IPX4.',
      longDescription:
        'Soluciones de calefacción radiante eficaces para quienes aprecian el ambiente elegante y el calor. La calefacción por infrarrojos es la forma perfecta de calentar un espacio sin la sequedad polvorienta de la calefacción por convección tradicional, con excelente eficiencia energética, reduciendo el consumo eléctrico hasta un 80%. Los calefactores JH se utilizan principalmente en patios, terrazas semiabiertas, restaurantes y talleres. Cuenta con elementos de calefacción aeroespaciales duraderos con placa de calefacción arqueada, adecuados para montaje en pared con clasificación IPX4.',
      category: 'Calefactor de Infrarrojos',
      features: ['Ecológico', 'Seguro y Silencioso', 'Larga Vida Útil', '350°C Alta Temp'],
      specs: [
        { label: 'Modelo', value: 'NR10/18/24/32/40-13A' },
        { label: 'Potencia', value: '2400W' },
        { label: 'Área de Cobertura', value: '30 m²' },
        { label: 'Voltaje/Frecuencia', value: '230V, 50/60Hz' },
        { label: 'Corriente Nominal', value: '10.4A' },
        { label: 'Temperatura Superficial', value: '300°C' },
        { label: 'Dimensiones', value: '1500×189×67mm' },
        { label: 'Peso N/B', value: '8.8/10.6 kg' },
      ],
    },
    p2: {
      name: 'Serie 13B',
      description: 'Serie de calefactores radiantes por infrarrojos lejanos con control remoto e indicador LED. Eficiencia energética para interiores, talleres y restaurantes. Montaje en pared con protección IPX4.',
      longDescription:
        'La Serie 13B presenta un diseño clásico y ligero con excelente rendimiento por eficiencia energética. Equipada con termostato y control remoto, ofrece una operación cómoda con indicador LED rojo. Los elementos de calefacción aeroespaciales duraderos con placa arqueada proporcionan una amplia cobertura radiante y una tasa de conversión eléctrica de hasta el 99%. Ideal para salas de estar, dormitorios, restaurantes y talleres. Montaje en pared con clasificación IPX4.',
      category: 'Calefactor de Infrarrojos',
      features: ['Control Remoto', 'Indicador LED', 'Ecológico', 'Alta Eficiencia', 'Superficie 300°C'],
      specs: [
        { label: 'Modelo', value: 'NR10/18/24/32-13B' },
        { label: 'Potencia', value: '2400W' },
        { label: 'Área de Cobertura', value: '30 m²' },
        { label: 'Voltaje/Frecuencia', value: '230V, 50/60Hz' },
        { label: 'Corriente Nominal', value: '10.4A' },
        { label: 'Temperatura Superficial', value: '300°C' },
        { label: 'Dimensiones', value: '1500×189×67mm' },
        { label: 'Peso N/B', value: '8.8/10.6 kg' },
      ],
    },
    p3: {
      name: 'Serie 13C',
      description: 'Serie de calefactores radiantes por infrarrojos lejanos con altavoz Bluetooth integrado para patios, restaurantes y espacios semiabiertos. Eficiencia energética con montaje en pared y protección IPX4.',
      longDescription:
        'La serie 13C está diseñada para patios y espacios semiabiertos, con altavoz Bluetooth integrado para reproducir música mientras aporta calor radiante por infrarrojos lejanos. Puede conectarse a un teléfono móvil u otro dispositivo compatible para audio, pero la función Bluetooth no controla la potencia ni la temperatura del calefactor. Incorpora 4 niveles de potencia con excelente eficiencia energética: 25%, 50%, 75% y 100%. El panel de calefacción está recubierto con un revestimiento NANO especial para mejorar la emisividad infrarroja. Ideal para restaurantes y talleres con montaje en pared, clasificación IPX4.',
      category: 'Calefactor de Infrarrojos',
      features: ['Altavoz Bluetooth', '4 Niveles de Potencia', 'Confort por Infrarrojos', 'Audio Bluetooth', 'Funcionamiento Silencioso'],
      specs: [
        { label: 'Modelo', value: 'NR10/18/24/32-13C' },
        { label: 'Potencia', value: '1800W' },
        { label: 'Área de Cobertura', value: '20 m²' },
        { label: 'Voltaje/Frecuencia', value: '230V, 50/60Hz' },
        { label: 'Corriente Nominal', value: '7.8A' },
        { label: 'Temperatura Superficial', value: '300°C' },
        { label: 'Dimensiones', value: '1370×189×67mm' },
        { label: 'Peso N/B', value: '8.3/10.2 kg' },
        { label: 'Carga de Contenedor', value: '705/1632; 480/1156; 355/884; 270/612' },
      ],
    },
    p4: {
      name: 'Serie 22B',
      description: 'Calefactor radiante de panel de cerámica vidriada premium con control de app WiFi Tuya. Eficiencia energética y calefacción rápida para patios, restaurantes y talleres. Montaje en pared con protección IPX4.',
      longDescription:
        'JH-NR22-22B presenta paneles de calefacción radiante de cerámica vidriada premium que calientan de forma rápida y uniforme, con resistencia al calor de hasta 950°C. El efecto de reflexión especial del vidrio crea un aspecto moderno impresionante para cualquier habitación. Equipado con control remoto y soporte de app WiFi Tuya para operación conveniente. Proporciona calefacción limpia con excelente eficiencia energética, sin ruido, sin viento y sin sequedad. Ideal para patios, restaurantes y talleres. Montaje en pared con clasificación IPX4.',
      category: 'Calefactor de Infrarrojos',
      features: ['App WiFi Tuya', 'Control Remoto', 'Panel Cerámico Vidriado', 'Calefacción Rápida', 'Cuidado de la Salud'],
      specs: [
        { label: 'Modelo', value: 'NR16/22/32-22B' },
        { label: 'Potencia', value: '1.6/2.2/3.2 kW' },
        { label: 'Área de cobertura', value: '20/30/40 m²' },
        { label: 'Voltaje/Frecuencia', value: '220-240V~50/60Hz' },
        { label: 'Corriente nominal', value: '7/9.6/13.9A' },
        { label: 'Temperatura de superficie', value: '380°C' },
        { label: 'Dimensiones', value: '810/1160/1660 × 180 × 77 mm' },
        { label: 'Peso N/G', value: '5/6.1; 7/8.2; 9.9/11.7 kg' },
        { label: 'Carga de contenedor', value: '728/1638; 507/1162; 377/826' },
      ]
    },
    p5: {
      name: 'Serie 13W',
      description: 'Serie inteligente de calefactores radiantes por infrarrojos lejanos con app WiFi Tuya y control remoto LCD. Eficiencia energética para patios, restaurantes y talleres. Montaje en pared con protección IPX4.',
      longDescription:
        "La serie 13W combina la app Tuya WiFi, mando LCD, pantalla LED y cuatro niveles de potencia. Para interiores y terrazas o balcones cubiertos con pared adecuada, utilice soportes compatibles y las distancias del modelo. IPX4 indica protección contra salpicaduras.",
      category: 'Calefactor de Infrarrojos',
      features: ['App WiFi Tuya', 'Pantalla LED', 'Control Remoto LCD', '4 Niveles de Potencia', 'IPX4 Resistente al Agua'],
      specs: [
        { label: 'Modelo', value: 'NR10/18/24/32-13W' },
        { label: 'Potencia', value: '1.0/1.8/2.4/3.2 kW' },
        { label: 'Área de cobertura', value: '10/20/30/40 m²' },
        { label: 'Voltaje/Frecuencia', value: '220-240V~50/60Hz' },
        { label: 'Corriente nominal', value: '4.3/7.8/10.4/13.9A' },
        { label: 'Temperatura de superficie', value: '300°C' },
        { label: 'Dimensiones', value: '755/1150/1655/2155 × 189 × 67 mm' },
        { label: 'Peso N/G', value: '4.4/5.5; 6.9/8.1; 9.5/11.3; 12.3/14.3 kg' },
        { label: 'Carga de contenedor', value: '840/1680/2100; 530/1080/1350; 570/900/980; 350/700/800' },
      ]
    },
    p6: {
      name: 'Serie 14A',
      description: 'Calefactor radiante de infrarrojos lejanos de diseño arqueado clásico con múltiples opciones de potencia. Perfecto para patios, restaurantes, talleres y montaje en pared. Eficiencia energética con protección IPX4.',
      longDescription:
        "La serie 14A utiliza un panel curvo con nanorrevestimiento y potencias de 1000W a 4000W, sin controlador integrado. Elija una pared adecuada en interiores o zonas cubiertas y confirme soportes, distancias y control del modelo. IPX4 indica protección contra salpicaduras.",
      category: 'Calefactor de Infrarrojos',
      features: ['Diseño Arqueado', 'Potencia Múltiple', 'IPX4 Resistente al Agua', 'Calefacción Rápida', 'Eficiente Energéticamente'],
      specs: [
        { label: 'Modelo', value: '' },
        { label: 'Potencia', value: '' },
        { label: 'Área de cobertura', value: '' },
        { label: 'Voltaje/Frecuencia', value: '' },
        { label: 'Corriente nominal', value: '' },
        { label: 'Temperatura de superficie', value: '' },
        { label: 'Dimensiones', value: '' },
        { label: 'Peso N/G', value: '' },
        { label: 'Carga de contenedor', value: '' },
      ]
    },
    p7: {
      name: 'Serie 14B',
      description: "Calefactor infrarrojo mural con mando para interiores y terrazas cubiertas con pared adecuada.",
      longDescription:
        "La serie 14B combina panel curvo con nanorrevestimiento, mando, indicador LED, cuatro niveles de potencia y temporizador de 0/2/4/6/8 horas. Instale en una pared adecuada en interiores o zonas cubiertas con soportes compatibles y las distancias indicadas. Su perfil delgado no implica compatibilidad con otras estructuras.",
      category: 'Calefactor de Infrarrojos',
      features: ['Control Remoto', 'Función Temporizador', 'Diseño Arqueado', 'IPX4 Resistente al Agua', 'Calefacción Rápida'],
      specs: [
        { label: 'Modelo', value: '' },
        { label: 'Potencia', value: '' },
        { label: 'Área de cobertura', value: '' },
        { label: 'Voltaje/Frecuencia', value: '' },
        { label: 'Corriente nominal', value: '' },
        { label: 'Temperatura de superficie', value: '' },
        { label: 'Dimensiones', value: '' },
        { label: 'Peso N/G', value: '' },
        { label: 'Carga de contenedor', value: '' },
      ]
    },
    p8: {
      name: 'Serie 23W',
      description: 'Calefactor infrarrojo ultrafino con app WiFi Tuya Smart, control por voz, mando y temporizador para interiores y patios cubiertos.',
      longDescription:
        "La serie 23W combina panel negro delgado con nanorrevestimiento, app Tuya Smart WiFi y comandos de voz compatibles. El mando incluido ofrece cuatro niveles de potencia y temporizador de 0/2/4/6/8 horas. Instale en pared adecuada en interiores o zonas cubiertas con soportes compatibles y las distancias del modelo.",
      category: 'Calefactor de Infrarrojos',
      features: ['App Tuya Smart', 'Control por Voz', 'Control Remoto', 'Función Temporizador', '4 Niveles de Potencia', 'Calefacción Rápida'],
      specs: [
        { label: 'Modelo', value: 'NR10/18/24/32-23W' },
        { label: 'Potencia', value: '1.0/1.8/2.4/3.2 kW' },
        { label: 'Área de cobertura', value: '10/20/30/40 m²' },
        { label: 'Voltaje/Frecuencia', value: '220-240V~50/60Hz' },
        { label: 'Corriente nominal', value: '4.3/7.8/10.4/13.9A' },
        { label: 'Temperatura de superficie', value: '300°C' },
        { label: 'Dimensiones', value: '693/1093/1593/2093 × 151 × 52 mm' },
        { label: 'Peso N/G', value: '3.4/4.2; 5.3/6.4; 7.6/9.5; 9.9/12.5 kg' },
        { label: 'Carga de contenedor', value: '1248; 800; 528; 412 (20HQ)' },
      ]
    },
    p20: {
      name: 'Serie 23A',
      description: 'Calefactor infrarrojo ultrafino con mando convencional, temporizador y 4 niveles de potencia, sin WiFi ni app.',
      longDescription:
        'La serie 23A es un calefactor infrarrojo ultrafino manejado mediante un mando convencional, sin conexión WiFi ni app. El mando ofrece 4 niveles de potencia (25%/50%/75%/100%) y temporizador de 0/2/4/6/8 horas. Su panel negro con nanorrevestimiento proporciona calor radiante rápido, uniforme, silencioso y sin llama. Disponible de 1000W a 3200W para 10-40 m²; su perfil de 52 mm es ideal para viviendas, restaurantes, oficinas y patios cubiertos.',
      category: 'Calefactor de Infrarrojos',
      features: ['Control Remoto', 'Función Temporizador', '4 Niveles de Potencia', 'Diseño Delgado', 'Calefacción Rápida', 'Funcionamiento Silencioso'],
      specs: [
        { label: 'Modelo', value: '' },
        { label: 'Potencia', value: '' },
        { label: 'Área de cobertura', value: '' },
        { label: 'Voltaje/Frecuencia', value: '' },
        { label: 'Corriente nominal', value: '' },
        { label: 'Temperatura de superficie', value: '' },
        { label: 'Dimensiones', value: '' },
        { label: 'Peso N/G', value: '' },
        { label: 'Carga de contenedor', value: '' },
      ]
    },
    p21: {
      name: 'Serie 25W',
      description: 'Calefactor de infrarrojos lejanos de pared con WiFi integrado, control por app Tuya, pantalla LED de nivel y cuatro potencias de 1000 W a 3200 W.',
      longDescription:
        'La Serie 25W es un calefactor de infrarrojos lejanos de pared y perfil delgado con WiFi integrado para el control mediante la app Tuya Smart: encienda el panel, cambie el nivel de potencia y programe horarios desde el móvil, o utilice el mando inalámbrico incluido con su botón de emparejamiento WiFi. La pantalla LED roja de la caja de control muestra el nivel de potencia activo. Cuatro niveles de potencia van de 1000 W a 3200 W y cubren de 10 m² a 40 m², y todos los modelos comparten el mismo cuerpo de aluminio de 67 mm. Un elemento calefactor de infrarrojo lejano en espiral recorre el panel dentro de un cuerpo de aluminio extruido y lleva la cara de aluminio ranurada a 300 °C de temperatura superficial.',
      category: 'Calefactor de Infrarrojos',
      features: ['App WiFi Tuya', 'Pantalla LED de Nivel', 'Mando Inalámbrico', '4 Niveles de Potencia', 'Superficie a 300 °C', 'Cuerpo de 67 mm'],
      specs: [
        { label: 'Modelo', value: 'NR10/18/24/32-25W' },
        { label: 'Potencia', value: '1.0/1.8/2.4/3.2 kW' },
        { label: 'Área de cobertura', value: '10/20/30/40 m²' },
        { label: 'Voltaje/Frecuencia', value: '220-240V~50/60Hz' },
        { label: 'Corriente nominal', value: '4.3/7.8/10.4/13.9A' },
        { label: 'Temperatura de superficie', value: '300°C' },
        { label: 'Dimensiones', value: '715/1115/1615/2115 × 189 × 67 mm' },
        { label: 'Peso N/G', value: '4.4/5.5; 6.9/8.1; 9.5/11.3; 12.3/14.3 kg' },
        { label: 'Carga de contenedor', value: '945/1920/2176; 615/1290/1462; 435/885/1003; 345/705/799' },
      ]
    },
    p9: {
      name: 'JHL020A',
      description: 'Calefactor de fibra de carbono compacto con protección antivuelco. Perfecto para calefacción personal bajo escritorios o mesas.',
      longDescription:
        'JHL020A es un calefactor de mesa compacto y eficiente diseñado para calentamiento personal. Presenta un tubo de calefacción de fibra de carbono para distribución rápida y uniforme del calor. Equipado con control por interruptor de balancín y protección antivuelco para seguridad. El diseño de malla fría al tacto previene quemaduras accidentales mientras proporciona calor eficiente. La construcción ligera con enchufe europeo lo hace perfecto para uso doméstico o de oficina.',
      category: 'Calefactor Portátil',
      features: ['Protección Antivuelco', 'Malla Fría al Tacto', 'Diseño Compacto', 'Calefacción Rápida', 'Eficiente Energéticamente'],
      specs: [
        { label: 'Modelo', value: 'JHL020A' },
        { label: 'Nombre del Producto', value: 'Calefactor de Mesa' },
        { label: 'Voltaje', value: '220-240V~50Hz' },
        { label: 'Potencia', value: '1200W' },
        { label: 'Control', value: 'Interruptor de Balancín' },
        { label: 'Elemento de Calefacción', value: '1 Tubo de Calefacción de Fibra de Carbono' },
        { label: 'Enchufe', value: 'Enchufe Europeo' },
        { label: 'Cable', value: '1.8-1.9m' },
        { label: 'Material', value: 'Hierro, Aluminio' }
      ]
    },
    p10: {
      name: 'JHL023',
      description: 'Calefactor de fibra de carbono potente con configuraciones térmicas dobles y asa plegable. Solución de calefacción portátil para cualquier espacio.',
      longDescription:
        'JHL023 es un calefactor de pie potente y portátil que presenta tubos dobles de calefacción de fibra de carbono para calor eficiente. Dos configuraciones térmicas (750W + 750W) permiten un control flexible de la temperatura. El interruptor rotativo proporciona operación fácil, mientras que el asa plegable lo hace muy portátil. Fabricado con construcción duradera de plástico y acero, este calefactor es perfecto para salas de estar, dormitorios, oficinas o cualquier espacio que necesite calor adicional.',
      category: 'Calefactor Portátil',
      features: ['Configuraciones Térmicas Dobles', 'Asa Plegable', 'Calefacción de Fibra de Carbono', 'Diseño Portátil', 'Operación Fácil'],
      specs: [
        { label: 'Modelo', value: 'JHL023' },
        { label: 'Nombre del Producto', value: 'Calefactor de Pie' },
        { label: 'Voltaje', value: '220-240V~50Hz' },
        { label: 'Potencia', value: '1500W (máx.)' },
        { label: 'Configuraciones', value: '750W + 750W' },
        { label: 'Control', value: 'Interruptor Rotativo' },
        { label: 'Elemento de Calefacción', value: 'Tubo de Calefacción de Fibra de Carbono x 2' },
        { label: 'Enchufe', value: 'Enchufe Europeo' },
        { label: 'Cable', value: '1.8-1.9m' },
        { label: 'Material', value: 'Plástico, Acero' },
        { label: 'Característica', value: 'Asa Plegable' }
      ]
    },
    p11: {
      name: 'JHL023-05',
      description: 'Calefactor de fibra de carbono compacto con configuraciones térmicas dobles. Calefacción eficiente energéticamente para espacios pequeños y medianos.',
      longDescription:
        'JHL023-05 es un calefactor de pie compacto y eficiente energéticamente perfecto para espacios pequeños y medianos. Presenta tubos dobles de calefacción de fibra de carbono con dos configuraciones ajustables (400W + 400W), proporcionando calor cómodo mientras economiza energía. El interruptor rotativo permite operación fácil, y el asa plegable garantiza almacenamiento y portabilidad convenientes. Ideal para dormitorios, oficinas domésticas o espacios de trabajo personales.',
      category: 'Calefactor Portátil',
      features: ['Configuraciones Térmicas Dobles', 'Asa Plegable', 'Calefacción de Fibra de Carbono', 'Compacto y Portátil', 'Eficiente Energéticamente'],
      specs: [
        { label: 'Modelo', value: 'JHL023-05' },
        { label: 'Nombre del Producto', value: 'Calefactor de Pie' },
        { label: 'Voltaje', value: '220-240V~50Hz' },
        { label: 'Potencia', value: '800W (máx.)' },
        { label: 'Configuraciones', value: '400W + 400W' },
        { label: 'Control', value: 'Interruptor Rotativo' },
        { label: 'Elemento de Calefacción', value: 'Tubo de Calefacción de Fibra de Carbono x 2' },
        { label: 'Enchufe', value: 'Enchufe Europeo' },
        { label: 'Cable', value: '1.8-1.9m' },
        { label: 'Material', value: 'Plástico, Acero' },
        { label: 'Característica', value: 'Asa Plegable' }
      ]
    },
    p12: {
      name: 'JHL021-S',
      description: 'Calefactor versátil con luz LED ambiente y altavoz Bluetooth. Perfecto para crear un ambiente acogedor.',
      longDescription:
        'JHL021-S es un calefactor innovador que combina funcionalidad de calefacción con características de entretenimiento. Presenta iluminación LED de 16 colores para crear el ambiente perfecto en cualquier configuración. Equipado con altavoz Bluetooth para transmitir música desde tu dispositivo móvil. El interruptor de balancín controla los ajustes de calor, mientras que el control remoto controla las funciones Bluetooth y LED. Incluye protección antivuelco para seguridad y malla de tacto frío para prevenir quemaduras. El tubo de calefacción de fibra de carbono proporciona calefacción rápida y eficiente. Ideal para salas de estar, dormitorios o cualquier espacio interior donde desees calor y ambiente.',
      category: 'Calefactor Portátil',
      features: ['Luz LED de 16 Colores', 'Altavoz Bluetooth', 'Protección Antivuelco', 'Malla Fría al Tacto', 'Control Remoto'],
      specs: [
        { label: 'Modelo', value: 'JHL021-S' },
        { label: 'Nombre del Producto', value: 'Calefactor LED con Bluetooth' },
        { label: 'Voltaje', value: '220-240V~50Hz' },
        { label: 'Potencia', value: '1500W' },
        { label: 'Control', value: 'Interruptor de Balancín (Calor), Control Remoto (Bluetooth y LED)' },
        { label: 'LED', value: 'Luz de 16 colores' },
        { label: 'Elemento de Calefacción', value: '1 Tubo de Calefacción de Fibra de Carbono' },
        { label: 'Enchufe', value: 'Enchufe Europeo' },
        { label: 'Cable', value: '1.8-1.9m' },
        { label: 'Seguridad', value: 'Protección Antivuelco, Malla Fría al Tacto' },
        { label: 'Material', value: 'Hierro, Aluminio' }
      ]
    },
    p13: {
      name: 'JHL004-B',
      description: 'Potente calefactor de halógeno de 3000W con poste telescópico. Altura ajustable para cobertura de calefacción personalizada.',
      longDescription:
        'JHL004-B es un potente calefactor de pie para terraza diseñado para espacios exteriores y semi-exteriores. Presenta dos tubos de calefacción halógenos que proporcionan calor eficiente y cómodo con tres ajustes de potencia ajustables (1200W-1800W-3000W). El poste telescópico permite ajustar la altura desde 1.6m hasta 2.08m, permitiendo cobertura de calefacción personalizada para diferentes áreas. Equipado con control remoto y botón táctil para operación conveniente. Incluye protección antivuelco para seguridad. La construcción de hierro y aluminio asegura durabilidad manteniendo una apariencia elegante. Perfecto para terrazas, patios, jardines y áreas de entretenimiento al aire libre.',
      category: 'Calefactor Portátil',
      features: ['Alta Potencia 3000W', 'Poste Telescópico', '3 Ajustes de Calor', 'Control Remoto y Táctil', 'Protección Antivuelco'],
      specs: [
        { label: 'Modelo', value: 'JHL004-B' },
        { label: 'Nombre del Producto', value: 'Calefactor de Pie para Terraza' },
        { label: 'Voltaje', value: '220-240V~50Hz' },
        { label: 'Potencia', value: '3000W (máx.)' },
        { label: 'Ajustes', value: '1200W-1800W-3000W' },
        { label: 'Control', value: 'Control remoto y botón táctil' },
        { label: 'Altura', value: 'Poste telescópico (1.6m - 2.08m)' },
        { label: 'Elemento de Calefacción', value: '2 Tubos de Calefacción Halógenos' },
        { label: 'Enchufe', value: 'Enchufe Europeo' },
        { label: 'Cable', value: '1.8-1.9m' },
        { label: 'Seguridad', value: 'Protección Antivuelco' },
        { label: 'Material', value: 'Hierro, Aluminio' }
      ]
    },
    p14: {
      name: 'JHL001-BZ',
      description: 'Eficiente calefactor de halógeno para terraza con diseño de poste fijo. Solución de calefacción elegante y limpia para espacios exteriores.',
      longDescription:
        'JHL001-BZ es un calefactor de terraza elegante y eficiente con diseño de poste fijo. Equipado con dos tubos de calefacción halógenos proporcionando tres ajustes de potencia ajustables (900W-1200W-2100W) para un calor cómodo. El diseño cubierto de tela añade un toque elegante manteniendo la funcionalidad. Tanto el control remoto como el botón táctil permiten una operación fácil. Incluye protección antivuelco para uso seguro. Los materiales de hierro y aluminio aseguran durabilidad y distribución eficiente del calor. Ideal para terrazas cubiertas, pérgolas y otros espacios semi-exteriores donde el estilo y el calor son igualmente importantes.',
      category: 'Calefactor Portátil',
      features: ['3 Ajustes de Calor', 'Diseño de Tela', 'Control Remoto y Táctil', 'Protección Antivuelco', 'Calefacción Halógena Eficiente'],
      specs: [
        { label: 'Modelo', value: 'JHL001-BZ' },
        { label: 'Nombre del Producto', value: 'Calefactor de Tela para Terraza' },
        { label: 'Voltaje', value: '220-240V~50Hz' },
        { label: 'Potencia', value: '2100W (máx.)' },
        { label: 'Ajustes', value: '900W-1200W-2100W' },
        { label: 'Control', value: 'Control remoto y botón táctil' },
        { label: 'Altura', value: 'Poste fijo' },
        { label: 'Elemento de Calefacción', value: '2 Tubos de Calefacción Halógenos' },
        { label: 'Enchufe', value: 'Enchufe Europeo' },
        { label: 'Cable', value: '1.8-1.9m' },
        { label: 'Seguridad', value: 'Protección Antivuelco' },
        { label: 'Material', value: 'Hierro, Aluminio' }
      ]
    },
    p15: {
      name: 'JHD028-B',
      description: 'Potente calefactor de halógeno de 2000W montado en el techo con tres ajustes de calor. Perfecto para espacios interiores con techos altos.',
      longDescription:
        'JHD028-B es un calefactor montado en el techo diseñado para calefacción eficiente en espacios interiores. Presenta dos tubos de calefacción halógenos proporcionando calefacción potente y uniforme con tres ajustes ajustables (800W-1200W-2000W). El montaje en el techo ahorra espacio en el suelo mientras proporciona excelente distribución de calor desde arriba. Equipado con control remoto y botón táctil para operación conveniente. La construcción de aluminio y hierro asegura durabilidad y conducción eficiente del calor. Ideal para habitaciones con techos altos, garajes, talleres o cualquier espacio donde se prefiera el montaje en el techo. Proporciona calor constante y cómodo sin ocupar espacio en el suelo.',
      category: 'Calefactor Portátil',
      features: ['Montaje en Techo', '2 Tubos Halógenos', '3 Ajustes de Calor', 'Control Remoto y Táctil', 'Ahorro de Espacio'],
      specs: [
        { label: 'Modelo', value: 'JHD028-B' },
        { label: 'Nombre del Producto', value: 'Calefactor de Techo' },
        { label: 'Voltaje', value: '220-240V~50Hz' },
        { label: 'Potencia', value: '2000W (máx.)' },
        { label: 'Ajustes', value: '800W-1200W-2000W' },
        { label: 'Control', value: 'Control remoto y botón táctil' },
        { label: 'Elemento de Calefacción', value: '2 Tubos de Calefacción Halógenos' },
        { label: 'Enchufe', value: 'Enchufe Europeo' },
        { label: 'Cable', value: '1.8-1.9m' },
        { label: 'Material', value: 'Aluminio, Hierro' }
      ]
    },
    p16: {
      name: 'JHG019-B',
      description: 'Calefactor inteligente de carbón con función de temporizador. El diseño montado en pared ahorra espacio mientras proporciona calor potente.',
      longDescription:
        'JHG019-B es un calefactor de terraza inteligente montado en la pared Featuring advanced carbon fiber heating technology. Presenta tres ajustes ajustables para calor potente y eficiente. Featuring multiple control options including rocker switch, remote control, and touch button for ultimate convenience. Featuring an 8-hour timer function, the device provides energy savings and peace of mind. El tubo de calentamiento de carbón asegura calentamiento rápido con excelente distribución de calor. Featuring a wall-mounted design that saves valuable floor space while providing powerful warmth. Featuring durable iron and aluminum construction. Perfecto para terrazas, garajes, talleres o cualquier espacio interior/exterior donde se prefiera el montaje en pared.',
      category: 'Calefactor Portátil',
      features: ['Montaje en Pared', 'Calentamiento de Carbón', 'Temporizador de 8 Horas', 'Múltiples Opciones de Control', 'Diseño Ahorro de Espacio'],
      specs: [
        { label: 'Modelo', value: 'JHG019-B' },
        { label: 'Nombre del Producto', value: 'Calefactor de Pared para Terraza' },
        { label: 'Voltaje', value: '220-240V~50Hz' },
        { label: 'Potencia', value: '2000W (máx.)' },
        { label: 'Ajustes', value: '650W-1300W-2000W' },
        { label: 'Interruptor', value: 'Interruptor de balancín, control remoto y control táctil' },
        { label: 'Remoto', value: 'Sí' },
        { label: 'Temporizador', value: 'Sí, hasta 8 horas' },
        { label: 'Elemento de Calefacción', value: 'Tubo de calentamiento de carbón' },
        { label: 'Enchufe', value: 'Enchufe Europeo' },
        { label: 'Cable', value: '1.8-1.9m' },
        { label: 'Material', value: 'Hierro, Aluminio' }
      ]
    },
    p17: {
      name: 'JH-104',
      description: 'Calefactor eficiente montado en pared con tubo halógeno oro rojo. Diseño compacto perfecto para espacios interiores.',
      longDescription:
        'JH-104 es un calefactor eficiente montado en pared diseñado para espacios interiores. Presenta un tubo halógeno oro rojo que proporciona calefacción rápida y eficiente. El diseño compacto con tres ajustes de calor ajustables (800W/1300W/2000W) te permite personalizar tu nivel de confort. Equipado con control remoto para operación conveniente. El diseño elegante se adapta perfectamente a cualquier habitación mientras proporciona calor potente. Ideal para salas de estar, dormitorios, oficinas o cualquier espacio interior donde se prefiera el montaje en pared.',
      category: 'Calefactor Portátil',
      features: ['Montado en Pared', 'Tubo Halógeno Oro Rojo', '3 Ajustes de Calor', 'Control Remoto', 'Diseño Compacto'],
      specs: [
        { label: 'Modelo', value: 'JH-104' },
        { label: 'Nombre del Producto', value: 'Calefactor de Pared' },
        { label: 'Voltaje', value: '220V ~ 50Hz' },
        { label: 'Potencia', value: '2000W (máx.)' },
        { label: 'Ajustes', value: '800W / 1300W / 2000W' },
        { label: 'Control', value: 'Control remoto' },
        { label: 'Elemento de Calefacción', value: 'Tubo halógeno oro rojo' },
        { label: 'Enchufe', value: 'Enchufe Europeo' },
        { label: 'Cable', value: '3m' },
        { label: 'Dimensiones', value: '63.5cm × 10cm' },
        { label: 'Peso', value: '2.2kg' }
      ]
    },
    p18: {
      name: 'JH-106',
      description: 'Calefactor compacto montado en techo con tecnología de fibra de carbono. Perfecto para espacios interiores pequeños.',
      longDescription:
        'JH-106 es un calefactor compacto montado en techo diseñado para calefacción eficiente en espacios interiores pequeños. Presenta tecnología de tubo de calefacción de fibra de carbono para calefacción rápida y eficiente. El interruptor de cordón proporciona fácil control de encendido/apagado. Tres ajustes de calor ajustables (600W/1000W/1500W) te permiten personalizar tu nivel de confort. El montaje en techo ahorra espacio en el suelo mientras proporciona excelente distribución de calor. Ideal para habitaciones pequeñas, baños, cocinas o cualquier espacio donde se prefiera el montaje en techo.',
      category: 'Calefactor Portátil',
      features: ['Montado en Techo', 'Tecnología de Fibra de Carbono', '3 Ajustes de Calor', 'Interruptor de Cordón', 'Ahorro de Espacio'],
      specs: [
        { label: 'Modelo', value: 'JH-106' },
        { label: 'Nombre del Producto', value: 'Calefactor de Techo' },
        { label: 'Voltaje', value: '220V ~ 50Hz' },
        { label: 'Potencia', value: '1500W (máx.)' },
        { label: 'Ajustes', value: '600W / 1000W / 1500W' },
        { label: 'Control', value: 'Interruptor de cordón' },
        { label: 'Elemento de Calefacción', value: 'Tubo de calefacción de fibra de carbono' },
        { label: 'Enchufe', value: 'Enchufe Europeo' },
        { label: 'Cable', value: '3m' },
        { label: 'Dimensiones', value: '42cm (diámetro) × 30cm (altura)' },
        { label: 'Peso', value: '2.3kg' }
      ]
    },
    p19: {
      name: 'JH-3000',
      description: 'Calefactor de terraza ajustable premium con control por APP de teléfono inteligente. Perfecto para entretenimiento al aire libre.',
      longDescription:
        'JH-3000 es un calefactor de terraza ajustable premium diseñado para entretenimiento al aire libre. Presenta tecnología avanzada de tubo de calefacción de fibra de carbono para calefacción potente y eficiente. La altura ajustable (160-205cm) te permite personalizar la cobertura de calefacción. Equipado con control remoto y APP de teléfono inteligente para máxima conveniencia. Tres ajustes de calor ajustables (1200W/1800W/3000W) proporcionan confort personalizable. La base robusta con diámetro de 45cm garantiza estabilidad. Perfecto para terrazas, patios, jardines y áreas de entretenimiento al aire libre.',
      category: 'Calefactor Portátil',
      features: ['Altura Ajustable', 'Calefacción de Fibra de Carbono', '3 Ajustes de Calor', 'APP de Teléfono Inteligente', 'Control Remoto'],
      specs: [
        { label: 'Modelo', value: 'JH-3000' },
        { label: 'Nombre del Producto', value: 'Calefactor de Terraza Negro Ajustable' },
        { label: 'Voltaje', value: '220V ~ 50Hz' },
        { label: 'Potencia', value: '3000W (máx.)' },
        { label: 'Ajustes', value: '1200W / 1800W / 3000W' },
        { label: 'Control', value: 'Control remoto y APP de teléfono inteligente' },
        { label: 'Elemento de Calefacción', value: 'Tubo de calefacción de fibra de carbono' },
        { label: 'Enchufe', value: 'Enchufe Europeo' },
        { label: 'Cable', value: '5m' },
        { label: 'Altura', value: 'Ajustable, 160-205cm' },
        { label: 'Diámetro de la Base', value: '45cm' },
        { label: 'Peso', value: '12kg' }
      ]
    },
  },
};
